import { useLocation, useSearchParams } from "react-router-dom";
import { useAppSelector } from "./redux.hook";
import { useEffect, useRef } from "react";

export const useSearchQuery = (name: string): string => {
  const location = useLocation();
  const [query] = useSearchParams(location.search);

  return query.get(name) || "";
};

export const useUserInfo = () => {
  const user = useAppSelector((state) => state.auth.user);

  return user;
};

export const useSkipInitEffect = (callback: Function, dependency: any[]) => {
  const ref = useRef(false);

  useEffect(() => {
    ref.current = true;
    if (ref.current) {
      callback();
    }
  }, [...dependency]);
};
